import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isModalOpen: false,
  modalViewParams: null,
  reload: false,
}

const slice = createSlice({
  name: 'smsSet',
  initialState,
  reducers: {
    openModal(state) {
      state.isModalOpen = true
    },
    closeModal(state) {
      state.isModalOpen = false
      state.modalViewParams = null
    },
    setModalViewParams(state, action) {
      state.modalViewParams = action.payload
    },
    setReload(state, action) {
      state.reload = action.payload
    },
  },
})

export const reducer = slice.reducer

export const openModal = () => (dispatch) => dispatch(slice.actions.openModal())
export const closeModal = () => (dispatch) => dispatch(slice.actions.closeModal())
export const setModalViewParams = (params) => (dispatch) =>
  dispatch(slice.actions.setModalViewParams(params))
export const setReload = (reload) => (dispatch) =>
  dispatch(slice.actions.setReload(reload))

export default slice
